import {
  RESERVED_SCOPE_NAME,
  type HomeSettings,
} from '~/features/home/utils/homeSettings';
import { ServiceRequestConfig } from '~/services/createService';

import { writeHomeScopePreference } from './applyHomeScope';
import { serializeScopeWrite } from './serializeScopeWrite';

export type ClearHomeScopeRequest = {
  settings: HomeSettings;
};

function settingsWithClearedScope(settings: HomeSettings) {
  const pointer = settings.scope;
  return {
    ...settings,
    scope:
      pointer?.savedSearchId != null
        ? {
            savedSearchId: pointer.savedSearchId,
            name: pointer.name || RESERVED_SCOPE_NAME,
            description: '',
            query: [],
          }
        : null,
  };
}

export function clearHomeScope(
  request: ClearHomeScopeRequest,
  options: ServiceRequestConfig = {},
) {
  return serializeScopeWrite(async (currentSettings) => {
    // Keep `savedSearchId`: re-deriving by name can miss, and the next
    // apply would then POST a name the user already owns. The saved search
    // itself is left alone -- it is a user-visible artifact in Search.
    const next = settingsWithClearedScope(currentSettings(request.settings));
    await writeHomeScopePreference(next, options);
    return { settings: next };
  });
}
